import VueI18n from "vue-i18n"

import i18n from "@/i18n"
import { ConditionKey, ConditionValue } from "@/types/common.type"

export interface OfferConditionOption {
  backKey: ConditionKey
  backValue: ConditionValue
  description: VueI18n.TranslateResult
  value: ConditionValue
}

export const conditions: OfferConditionOption[] = [
  { backKey: "new", backValue: 0, description: i18n.t("common.condition.new"), value: 1 },
  {
    backKey: "p_discount",
    backValue: 0,
    description: i18n.t("common.condition.p_discount"),
    value: 1
  },
  {
    backKey: "refurbished",
    backValue: 0,
    description: i18n.t("common.condition.refurbished"),
    value: 2
  },
  { backKey: "used", backValue: 5, description: i18n.t("common.condition.used_5"), value: 3 },
  { backKey: "used", backValue: 4, description: i18n.t("common.condition.used_4"), value: 4 },
  { backKey: "used", backValue: 3, description: i18n.t("common.condition.used_3"), value: 5 },
  { backKey: "used", backValue: 2, description: i18n.t("common.condition.used_2"), value: 2 },
  { backKey: "used", backValue: 1, description: i18n.t("common.condition.used_1"), value: 1 },
  {
    backKey: "w_undetermined",
    backValue: 0,
    description: i18n.t("common.condition.w_undetermined"),
    value: 1
  }
]
